import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import useStyles from "../../styles";
import { Grid, Typography, Card, CardActionArea, CardActions, CardContent, TextField, Button, Paper, Tabs, Tab, Box, Dialog, IconButton, MenuItem, FormControl, Select, CircularProgress, DialogActions as MuiDialogActions, DialogTitle as MuiDialogTitle } from "@material-ui/core";
import {Phone as PhhoneIcon, PhoneDisabled as PhoneDisabledIcon, Close as CloseIcon, VolumeUp as VolumeUpIcon, VolumeOff as VolumeOffIcon, Mic as MicIcon, MicOff as MicOffIcon, TextRotationNone as TextRotationNoneIcon } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";

// import AddCallIcon from "./AddCallIcon";
import Dot from "../../../../components/Sidebar/components/Dot";
import ConferenceEditCustomer from "./ConferenceEditCustomer";
import ConferenceDisposition from "./ConferenceDisposition";
import DialpadIcon from '@mui/icons-material/Dialpad';

//store
import * as actions from "../../../../store/actions/actionIndex";
// uitility function
import { maskedNumber, notify } from "../../../../helpers/utility";
import Dtmf from "../DTMF/Dtmf";
import Timer from "../../../../helpers/Timer";

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Typography component="div" role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
			{value === index && <Box p={3}>{children}</Box>}
		</Typography>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

const styles = (theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: "absolute",
		insetInlineEnd: 0,
		top: 0,
		color: theme.palette.grey[500],
	},
});

const DialogTitle = withStyles(styles)((props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

const DialogActions = withStyles((theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(1),
	},
}))(MuiDialogActions);

function ConferenceCallConnect(props) {
	var classes = useStyles();
	const [confCount, setConfCount] = useState(0);
	const [open, setOpen] = useState(false);
	const [dialAction, setDialAction] = useState(false);
	const [confAction, setConfAction] = useState("");
	const [currentChannle, setChannle] = useState("")
	const [dialType, setDialType] = useState("EXTERNAL");
	const [phoneType, setPhoneType] = useState("Contact");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [vdn, setVdn] = useState(null);
	const [dtmf, setDtmf] = useState(false);
	const [dtmfVal, setDtmfVal] = useState("");
	const confStatusTimer = useRef(null);
	const[selectedVdnOption, setSelectedVdnOption] = useState("");
	const [agentDetail, setAgentDetails] = useState("");
	const [isAgentValue,setisAgentValue] = useState("")
	const maxDigits = window?.Configs?.maxDigitsAllowed ?? 15;
	const roomEndTimes = props.roomEndTimes || {};

	const handleClickOpen = () => {
		setOpen(true);
	
	};

	const handleClose = () => {
		setOpen(false);
	};

	 const handleDtmfOpen = (agentId, channle) => {
	 	setDtmf(true);
	  setChannle(channle)
	 };

	 const handleDtmfClose = () => {
	 	setDtmf(false);
	 };

 const cleanNumberForAPI = (value) => {
 return value.replace(/\D/g, "");
};


	const confDisconnect = (agentId, channel) => {
		setConfAction(channel);
		props.onConfDisconnect(agentId, channel);
		clearTimeout(confStatusTimer);
		setTimeout(function() {
			setConfCount(confCount + 1);
		}, 1000);
	};

	const backToAgent = (agentId, channel) => {
		setConfAction(channel);
		props.onBackToAgent(agentId, channel);
		clearTimeout(confStatusTimer);
		setTimeout(function() {
			setConfCount(confCount + 1);
		}, 1000);
	};

	const confMute = (agentId, channel, confno, mute, confFd, ztcChan, ztcConfno, actionType) => {
		setConfAction(channel);
		props.onConfMute(agentId, channel, confno, mute, confFd, ztcChan, ztcConfno, actionType);
		clearTimeout(confStatusTimer);
		setTimeout(function() {
			setConfCount(confCount + 1);
		}, 1000);
	};

	 const sendDtmf = () => {
	 	props.onSendDtmf(props.agentId, dtmfVal,currentChannle);
	 	setDtmfVal("");
	 	setDtmf(false);
	 };

	const confDial = (e) => {
		e.preventDefault();
		if(isAgentValue === "1" &&  agentDetail === "")
		{
		notify("Please select an agent")
		return ;
		}
		let confString = phoneType === "Contact" ? "NONE" : vdn;
        if (agentDetail && agentDetail !== "") {
        confString += ":" + agentDetail;  
       }
     const newPhoneNumber = cleanNumberForAPI(phoneNumber)
		props.onConfDial(props.agentId, newPhoneNumber, phoneType === "Contact" ? dialType : "INTERNAL", confString, props.agentState, "1");
		setDialAction(true);
	};

	if (dialAction && !props.loading && !props.error) {
		setDialAction(false);
		setOpen(false);
	}

	const { agentId, onGetConfDetails, OnGetOnlineAgent } = props;
useEffect(() => {
  onGetConfDetails(agentId);

  clearTimeout(confStatusTimer.current);
  confStatusTimer.current = setTimeout(() => {
    setConfCount(prev => prev + 1); 
  }, 4000);

  return () => clearTimeout(confStatusTimer.current);
}, [agentId, onGetConfDetails, confCount]);

	const handleChange = (value) => {
		const extractedVdn = value.split("-TVT-")[1]?.split(":")[0] || "";
		const getTransValue = props.confDetails.vdn_details.find(option => 
			option.name + "@@" + option.VDNCampaign + "-TVT-" + option.camp_or_dept + ":" + option.vdnnumber + "_1" === value
		);
		setVdn(value);
		setAgentDetails('')
		setPhoneNumber(vdnArr[extractedVdn]);  
		setSelectedVdnOption(extractedVdn); // Store only "hridesh"
		setisAgentValue(getTransValue.isAgentTrans) // store isAgentTrans value
	};

const handleAgentChange = (value) =>{
	setAgentDetails(value)
}

	let vdnDiv = "";
	let vdnOptions = "";
	let vdnArr = [];
	let number = []

	useEffect(() =>{  
		if (selectedVdnOption !== ""){
			OnGetOnlineAgent(agentId, selectedVdnOption);

		}
	},[selectedVdnOption, OnGetOnlineAgent])
	try {
		vdnOptions = props.confDetails.vdn_details.map((option) => {
			vdnArr[option.camp_or_dept] = option.vdnnumber;
			number[option.camp_or_dept] = option.isAgentTrans

			return (
				<MenuItem key={option.name} value={option.name + "@@" + option.VDNCampaign + "-TVT-" + option.camp_or_dept + ":" +  option.vdnnumber + "_1"}>
					{option.camp_or_dept}
				</MenuItem>
			);
		});
	} catch (e) {}
	if (props.confDetails.vdn_details && props.confDetails.vdn_details.length) {
		vdnDiv = (
			<>
				<div>
					<Typography className={classes.NumberText} color="textSecondary">
						Please select the VDN
					</Typography>
				</div>
				<div>
					<FormControl style={{ width: "285px" }} size="small" variant="outlined" className={classes.formControl}>
						<Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={vdn} onChange={(event) => handleChange(event.target.value, event.nativeEvent.target.innerText)}>
							{vdnOptions}
						</Select>
					</FormControl>
				</div>
				{isAgentValue === "1" &&(
					<>
				<div>
					<Typography className={classes.NumberText} color="textSecondary">
						Please select the Agent 
					</Typography>
				</div>
				<div>
					<FormControl style={{ width: "285px" }} size="small" variant="outlined" className={classes.formControl}>
				 <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={agentDetail} onChange={(event) => handleAgentChange(event.target.value)}>
						{props.agentDetail && props.agentDetail.length > 0 ? (
                props.agentDetail.map((agent, index) => (
           <MenuItem key={index} value={agent.agent_id}>
          {agent.agent_name}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No Online Agents Available</MenuItem>
    )}
						</Select>
					</FormControl>
				</div>
				</>
				)}
				
			</>
		);
	}
	// console.log(props.confDetails.room_details);
	return (
		<div className={classes.ConferenceCallConnect} container="true" spacing={1}>
			<Grid container spacing={1} style={{
				display: "flex",
				alignItems: "center"
			}}>
				{props.confDetails.room_details && props.confDetails.room_details.length > 0 ?
					props.confDetails.room_details.map((option) => (
						<Grid item xs={6} sm={3} key={option.cust_ph_no + option.chan_name}>
							<Card className={classes.card}>
								<CardContent>
									<div className={classes.CardTitle}>
										<Dot color={option.conf_leave === "1" ? "error" : "success"} style={{ textAlign: "start", width: "10%" }} />
										<Typography className={classes.CallStatusTitle} color="textSecondary" style={{ textAlign: "start", width: "40%" }}>
											{option.conf_leave === "1" ? "Disconnected" : "INCALL"}
										</Typography>
										<Typography className={classes.CallStatusTitle} color="textSecondary" style={{ textAlign: "end", marginInlineStart: "0px", width: "50%" }}>
											{"Conf Room " + option.confnum}
										</Typography>
									</div>
									<div className={classes.cardBody}>
										<Typography className={classes.CallNumber} color="textSecondary">
											<b>{option.cust_ph_no !== props.agentId ? (props.facilityConf.enable_number_mask ? (props.facilityConf.enable_number_mask === "1" ? maskedNumber(option.cust_ph_no, props.facilityConf.mask_start_pos, props.facilityConf.mask_end_pos) : option.cust_ph_no) : option.cust_ph_no) : props.agentId}</b>
										</Typography>
										<Typography className={classes.caller} color="textSecondary">
											{option.type}
											{/* {props.agentId === option.cust_ph_no ? "Agent" : "Customer"} */}
										</Typography>
		{option.conf_start_time && (
	 <div
  style={{
    display: "inline-flex",
    alignItems: "center",
    background: "#e3f2fd",
    padding: "3px 8px",
    borderRadius: "12px",
    fontSize: "16px",
    marginLeft: "6px",
    color: "#1976d2",
    fontWeight: "bold",
	marginTop: "10px"
  }}
>
  ⏱ <Timer startTime={Number(option.conf_start_time)} confLeave = {option.conf_leave} endTime={roomEndTimes[option.chan_name || option.cust_ph_no]} />
</div>
    )}</div>
								</CardContent>
								<CardActions   style={{
    backgroundColor: "black",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    gap: "2px",
  }}
>
									{/*<PlayPauseIcon />*/}
									{option.cust_ph_no !== props.agentId && props.agentState !== "CONF" && option.conf_leave !== "1" ? (
										<IconButton title="Back to Agent" onClick={() => backToAgent(props.agentId, option.chan_name)} style={{ color: "#aaa", padding: "0px", marginInlineStart: "0px" }}>
											{props.loading && props.actionType === "backToAgent" && confAction === "option.chan_name" ? <CircularProgress size={22} style={{ verticalAlign: "middle" }} /> : <TextRotationNoneIcon style={{ marginInlineEnd: "0px" }} />}
										</IconButton>
									) : (
										<IconButton title="Back to Agent" style={{ color: "currentColor", padding: "0px", marginInlineStart: "0px" }}>
											<TextRotationNoneIcon style={{ marginInlineEnd: "0px" }} />
										</IconButton>
									)}
									{option.conf_leave !== "1" ? (
										option.mike_title !== "Mute" ? (
											<IconButton title="Mute" onClick={() => confMute(props.agentId, option.chan_name, option.confno, option.msv, option.conf_fd, option.ztc_chan, option.ztc_confno, "mike")} style={{ color: "#aaa", padding: "0px",  }}>
												{props.loading && props.actionType === "mike" && confAction === "option.chan_name" ? <CircularProgress size={22} style={{ verticalAlign: "middle" }} /> : <MicOffIcon style={{ marginInlineEnd: "0px", marginInlineStart: "0px", color: "darkorange" }} />}
											</IconButton>
										) : (
											<IconButton title="Mute" onClick={() => confMute(props.agentId, option.chan_name, option.confno, option.msv, option.conf_fd, option.ztc_chan, option.ztc_confno, "mike")} style={{ color: "#aaa", padding: "0px",  }}>
												{props.loading && props.actionType === "mike" && confAction === "option.chan_name" ? <CircularProgress size={22} style={{ verticalAlign: "middle" }} /> : <MicIcon style={{ marginInlineEnd: "0px", marginInlineStart: "0px" }} />}
											</IconButton>
										)
									) : (
										<IconButton title="Mute" style={{ color: "currentColor", padding: "0px", marginInlineStart: "12px" }}>
											<MicIcon style={{ marginInlineEnd: "0px", marginInlineStart: "0px" }} />
										</IconButton>
									)}
									{option.conf_leave !== "1" ? (
										option.speaker_title !== "Mute" ? (
											<IconButton title="Hold" onClick={() => confMute(props.agentId, option.chan_name, option.confno, option.hsv, option.conf_fd, option.ztc_chan, option.ztc_confno, "speaker")} style={{ color: "#aaa", padding: "0px"}}>
												{props.loading && props.actionType === "speaker" && confAction === "option.chan_name" ? <CircularProgress size={22} style={{ verticalAlign: "middle" }} /> : <VolumeOffIcon style={{ marginInlineEnd: "0px", marginInlineStart: "0px", color: "darkorange" }} />}
											</IconButton>
										) : (
											<IconButton title="Hold" onClick={() => confMute(props.agentId, option.chan_name, option.confno, option.hsv, option.conf_fd, option.ztc_chan, option.ztc_confno, "speaker")} style={{ color: "#aaa", padding: "0px"}}>
												{props.loading && props.actionType === "speaker" && confAction === "option.chan_name" ? <CircularProgress size={22} style={{ verticalAlign: "middle" }} /> : <VolumeUpIcon style={{ marginInlineEnd: "0px", marginInlineStart: "0px" }} />}
											</IconButton>
										)
									) : (
										<IconButton title="Hold" style={{ color: "currentColor", padding: "0px", }}>
											<VolumeUpIcon style={{ marginInlineEnd: "0px", marginInlineStart: "0px" }} />
										</IconButton>
									)}
									{option.cust_ph_no !== props.agentId || props.callBack === "1" ? (
										<IconButton title="Hangup" style={{ color: "#aaa", padding: "0px",  }} onClick={() => confDisconnect(props.agentId, option.chan_name)}>
											{props.loading && props.actionType === "confDisconnect" && confAction === "option.chan_name" ? <CircularProgress size={22} style={{ verticalAlign: "middle" }} /> : <PhoneDisabledIcon style={{ marginInlineEnd: "0px", marginInlineStart: "0px" }} />}
										</IconButton>
									) : (
										<IconButton title="Hangup" style={{ color: "currentColor", padding: "0px",  }}>
											<PhoneDisabledIcon style={{ marginInlineEnd: "0px", marginInlineStart: "0px" }} />
										</IconButton>
									)}
									{option.cust_ph_no !== props.agentId && option.lead_id !== "0" ? <ConferenceEditCustomer leadId={option.lead_id} listId={option.list_id} sessionId={option.session_id} campaignId={option.campaign_id} /> : ""}
									{option.cust_ph_no !== props.agentId && option.conf_leave !== "1" ? <ConferenceDisposition  leadId={option.lead_id} listId={option.list_id} sessionId={option.session_id} campaignId={option.campaign_id} /> : ""}
									{option.cust_ph_no !== props.agentId && option.conf_leave !== "1" ? 
									<IconButton title="DTMF" style={{ color: "#aaa", padding: "0px", margin: "0px"}} onClick={()=>handleDtmfOpen(props.agentId, option.chan_name)}>
											<DialpadIcon style={{ marginInlineEnd: "0px", marginInlineStart: "0px" }} />
										</IconButton>
										: ""}
								</CardActions>
							</Card>
						</Grid>
					))
				:
				(
			<div
  style={{
    width: "100%",
  }}
>
  <Card
    className="data"
    style={{
      background: "#f6f7ff",
	  boxShadow: "none",
	  borderRadius: "10px"
    }}
  >
    <CardActionArea
      className={classes.AddCallActionArea}
      style={{
        padding: "0",
        margin: "0",
		gap: "10px"
      }}
    >
      <div>
        <Typography
          style={{
            fontSize: "16px",
            marginTop: "2px",
            color: "#6d6d80",
          }}
        >
       No active conference in this room
        </Typography>
      </div>
    </CardActionArea>
  </Card>
</div>
				)
				}

				<Grid item xs={6} sm={3}>
				{((props.agentState === "CONF" || props.agentState === "BREAK") && props.breakType === 'JoinedConference') && (
						<Card className={classes.AddCallcard} onClick={handleClickOpen} style={{ border: "1px solid blue", borderStyle: "double",minHeight:"25%" }}>
							<CardActionArea className={classes.AddCallActionArea} style={{marginTop:"0",display:"flex",padding:"5px 0"}}>
								{/* <AddCallIcon /> */}
								<svg width="15" height="15" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M47.2731 21.5054H28.4802V2.7124C28.4802 1.8563 27.3177 0 24.9928 0C22.6679 0 21.5054 1.8564 21.5054 2.7124V21.5055H2.7124C1.8564 21.5054 0 22.6679 0 24.9927C0 27.3175 1.8564 28.4801 2.7124 28.4801H21.5055V47.2732C21.5055 48.1291 22.6679 49.9856 24.9929 49.9856C27.3179 49.9856 28.4803 48.1291 28.4803 47.2732V28.4801H47.2734C48.1293 28.4801 49.9858 27.3177 49.9858 24.9927C49.9858 22.6677 48.1291 21.5054 47.2731 21.5054Z" fill="#C9CEE2" />
								</svg>
								<Typography style={{marginTop:"0",marginInlineStart:"10px"}} className={classes.AddMemberText} color="textSecondary">
									ADD MEMBER
								</Typography>
							</CardActionArea>
						</Card>
					)}
					{((props.agentState === "CONF" || props.agentState === "BREAK") && props.breakType === 'JoinedConference') && (
						<Dialog className="DialogConference" style={{ borderRadius: "4px" }} open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
							<DialogTitle id="form-dialog-title" className={classes.DialogTitle} onClose={handleClose}>
								Add Supervisor
							</DialogTitle>
							<DialogActions className="external-popup" style={{ display: "block" }}>
								<div style={{ width: "300px" }}>
									<Paper className={classes.PaperValue} square>
										<Tabs className="tabspop" style={{ minHeight: "36px" }} value={phoneType} indicatorColor="primary" textColor="primary" onChange={(event, value) => setPhoneType(value)}>
											<Tab className={classes.ExternalTab} label="Contact" value="Contact" />
											<Tab className={classes.VDATab} label="VDN" value="VDN" />
										</Tabs>
									</Paper>
								</div>
								<form className={classes.root} 
								onSubmit={confDial} noValidate autoComplete="off">
									{phoneType === "Contact" && (
										<>
											<div>
												<Typography className={classes.NumberText} color="textSecondary">
													Please select the mode
												</Typography>
											</div>
											<div>
												<FormControl style={{ width: "285px" }} size="small" variant="outlined" className={classes.formControl}>
													<Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={dialType} onChange={(event) => setDialType(event.target.value)}>
														<MenuItem value="INTERNAL">Internal</MenuItem>
														<MenuItem value="EXTERNAL">External</MenuItem>
													</Select>
												</FormControl>
											</div>
										</>
									)}
									{phoneType === "VDN" && vdnDiv}
									<div>
										<Typography className={classes.NumberText} color="textSecondary">
											Please enter the number
										</Typography>
									</div>
									<div>
						<TextField
									id="outlined-size-small"
									variant="outlined"
									size="small"
									margin="dense"
									value={phoneNumber}
									onChange={(event) => {
										const newValue = event.target.value;
										const allowedSymbols =
										window?.Configs?.allowedDialSymbols ?? "+\\-()#* .,/;";

										const escapedSymbols = allowedSymbols.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
										const regex = new RegExp(`^[0-9${escapedSymbols}]*$`);
										if (regex.test(newValue)) {
										const digitCount = newValue.replace(/\D/g, "").length;
										if (digitCount <= maxDigits) {
											setPhoneNumber(newValue);
										}
										}
									}}
									inputProps={{
										maxLength: 50, // soft cap to prevent huge input
										style: {
										height: "30px",
										padding: "3px",
										},
									}}
									className={classes.textControl}
									/>

									</div>
									<div style={{ paddingInlineEnd: "13px", paddingBottom: "25px" }}>
										<Button type="submit" variant="outlined" className={classes.CallButton} color="primary" size="small" >
											Dial
										</Button>
									</div>
								</form>
							</DialogActions>
						</Dialog>
					)}
						<Dialog className="DialogConference" style={{ borderRadius: "4px" }} open={dtmf} onClose={handleDtmfClose} aria-labelledby="customized-dialog-title">
							<DialogTitle id="dtmf-dialog-title" className={classes.DialogTitle} onClose={handleDtmfClose}>
								Send DTMF
							</DialogTitle>
							<DialogActions className="external-popup" style={{ display: "block" }}>
								<form className={classes.root} noValidate autoComplete="off">
									<div>
										<Typography className={classes.NumberText} color="textSecondary">
											Please enter the number
										</Typography>
									</div>
									<div>
										<TextField
											id="dtmf-outlined-size-small"
											defaultValue=""
											variant="outlined"
											size="small"
											margin="dense"
											value={dtmfVal}
											onChange={(event) => setDtmfVal(event.target.value)}
											inputProps={{
												style: {
													height: "30px",
													padding: "3px",
												},
											}}
											className={classes.textControl}
										/>
									</div>
									<div style={{ paddingRight: "13px", paddingBottom: "25px" }}>
										<Button variant="outlined" className={classes.CallButton} color="primary" size="small" onClick={sendDtmf}>
											Send
										</Button>
									</div>
								</form>
							</DialogActions>
						</Dialog> 
						<Dialog className="DialogConference dtmf-dialogue" style={{ borderRadius: "4px" }} open={dtmf} onClose={handleDtmfClose} aria-labelledby="customized-dialog-title">
					<Dtmf  handleDtmfClose= {handleDtmfClose} channel = {currentChannle} confFlag = "1"/>
			</Dialog>
				</Grid>
			</Grid>
		</div>
	);
}
const mapStateToProps = (state) => {
	return {
		error: state.agentConf.error,
		loading: state.agentConf.loading,
		actionType: state.agentConf.actionType,
		statusError: state.agentConf.statusError,
		statusLoading: state.agentConf.statusLoading,
		confDetails: state.agentConf.confDetails,
		custPhone: state.agentData.custPhone,
		leadId: state.agentData.leadId,
		breakType: state.agentData.breakType,
		agentState: state.agentData.agentState,
		agentId: state.agentData.agentId,
		facilityConf: state.agentConfig.facilityConf,
		callBack: state.agentData.callBack,
		agentDetail: state.agentConf.agentDetails,
		roomEndTimes: state.agentConf.roomEndTimes,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onGetConfDetails: (agentId) => dispatch(actions.getConfDetails(agentId)),
		onLeaveConf: (agentId) => dispatch(actions.leaveConf(agentId)),
		onJoinConf: (agentId, cond, confRoom, exten) => dispatch(actions.joinConf(agentId, cond, confRoom, exten)),
		onConfDisconnect: (agentId, channel) => dispatch(actions.confDisconnect(agentId, channel)),
		onBackToAgent: (agentId, channel) => dispatch(actions.backToAgent(agentId, channel)),
		onConfMute: (agentId, channel, confno, mute, confFd, ztcChan, ztcConfno, actionType) => dispatch(actions.confMute(agentId, channel, confno, mute, confFd, ztcChan, ztcConfno, actionType)),
		onConfDial: (agentId, phoneNumber, dialType, vdnSelect, agentState, confRoom) => dispatch(actions.confDial(agentId, phoneNumber, dialType, vdnSelect, agentState, confRoom)),
		onSendDtmf: (agentId, digit,channle) => dispatch(actions.sendDtmf(agentId, digit,)),
		OnGetOnlineAgent: (agentId, campName) => dispatch(
			actions.getOnlineAgent(agentId, campName)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ConferenceCallConnect);
